export default __webpack_public_path__ + "static/media/logo_clear.605895ec.png";